module.exports = __webpack_public_path__ + "img/pr-3.67ef7cc7.png";